<template>
  <div style="width:100%; height:100%;" class="white">
    <v-app-bar app color="primary" fixed  tile >
      <v-app-bar-nav-icon @click.native="$router.go(-1)">
        <v-icon medium color="white" >close</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>
        <span class="title white--text font-weight-bold">{{ $language.jobDetails['Job Details'] }}</span>
      </v-toolbar-title>

    </v-app-bar>
    <v-container pa-0 align-start>
    <v-row v-if="loading" no-gutters>
      <v-col cols="12" text-center align="center" justify="center">
        <v-progress-circular indeterminate :size="70" :width="7" color="primary"></v-progress-circular>
      </v-col>
      <v-col cols="12" text-center align="center" justify="center">
        <h4 class="grey--text text--darken-3 mt-3">{{ $language.jobDetails['Loading Job Details'] }}</h4>
      </v-col>
    </v-row>
    <v-row v-if="!loading" no-gutters>
      <v-col cols="12" text-center align="center" justify="center">
        <job-summary v-show="tab === 'Summary'" :edit-job="this.job" :has-started="false" summary-view="true" :is-hefe="false" :public-view="true" :status="'New'" @apply="applyDialog = true" @hire="hireDialog = true" @decline="declineDialog = true" @unpublish="unpublishDialog = true" @end-contract="endContractDialog = true" @publish="publishDialog = true"></job-summary>
      </v-col>
    </v-row>
    </v-container>
  </div>
</template>

<script>

import moment from 'moment'
import {
  object
} from 'rxfire/database'
import {
  map
} from 'rxjs/operators'
import JobSummary from '@/components/common/JobSummary'
const fb = require('@/services/firebaseConfig.js')

export default {
  props: ['jobRef', 'profileId', 'defaultTab'],
  components: {
    JobSummary
  },
  data () {
    return {
      expensesForm: false,
      numberRules: [
        (v) => (/[0-9]|\./).test(v) || this.$language.validations['Only numbers allowed'],
        (v) => (v && v >= 0 && v <= 1000000) || this.$language.validations['Invalid value']
      ],
      expensesReasonDialog: false,
      payment: {
        expenses: 0,
        tip: 0,
        hours: 0,
        compensation: 0
      },
      hefeManageJobsDialog: false,
      sentExpenses: false,
      expenses: null,
      expensesSummary: '',
      buttonLoading: false,
      loading: false,
      snackbar: {
        show: false,
        message: '',
        status: 'success'
      },
      sub: null,
      tab: 'Summary',
      messageText: null,
      job: {
        warnings: {
          All: {}
        },
        applicants: {},
        payments: {
          transactions: {}
        }
      },
      warnSub: '',
      messageGroup: null,
      chips: {
        name: 'All',
        id: 'All',
        avatar: 'people'
      },
      rating: {
        comment: '',
        rating: null,
        ratingDate: new Date()
      },
      profileDialog: false,
      applicantId: null,
      ratingProfileId: null,
      thisProfile: {},
      mini: true,
      drawer: false,
      totalChatHeight: 0,
      editDialog: false,
      publishDialog: false,
      unpublishDialog: false,
      applyDialog: false,
      hireDialog: false,
      declineDialog: false,
      cancelDialog: false,
      deleteDialog: false,
      startDialog: false,
      completeDialog: false,
      payDialog: false,
      payProcessDialog: false,
      ratingDialog: false,
      inviteDialog: false,
      withdrawDialog: false,
      statusDialog: false,
      endShiftDialog: false,
      endContractDialog: false,
      shiftStartDialog: false,
      manualTimeDialog: false,
      paymentReminderDialog: false,
      hefeFab: false,
      obrFab: false,
      inviteList: [],
      selectAll: '',
      listLength: 0,
      index: 1,
      index2: 1,
      index3: 4,
      menu: false,
      interval: null,
      secondsWorked: 0,
      showExpensePrompt: true,
      showExpensesForm: false,
      paymentId: null,
      selectedShifts: [],
      shiftPayAmount: 0,
      shiftDate: new Date().toISOString().slice(0, 10),
      thisLog: {

        hours: 0,
        reason: ''
      },
      menu1: false,
      nowDate: new Date().toISOString().slice(0, 10)
    }
  },

  mounted () {
    this.sub = object(fb.database.ref(`jobs/${this.$route.params.jobId}/public`))
      .pipe(map(change => ({
        _key: change.snapshot.key,
        ...change.snapshot.val()
      })))
      .subscribe(job => {
        this.job = job
        this.shiftPayAmount = this.job.compensation
        this.payment.compensation = this.job.compensation
        this.payment.hours = this.job.hours
        this.index += this.index
        this.index2 += this.index2
        this.loading = false
      })
  },
  destroyed () {
    clearInterval(this.interval)
    this.sub.unsubscribe()
  },
  computed: {

  },

  methods: {

  },

  watch: {

  },

  filters: {
    formatDate (val) {
      if (!val) {
        return '-'
      }
      let date = val.toDate()
      return moment(date).fromNow()
    },

    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      return moment(date).fromNow()
    },
    formatTime (val) {
      return moment(val).format('hh:mm:ss a')
    },
    trimLength (val) {
      if (val.length < 200) {
        return val
      }
      return `${val.substring(0, 200)}...`
    },
    formatHours (val) {
      if (!val) {
        return '-'
      }
      return parseFloat(val / 60 / 60).toFixed(2)
    },
    formatHoursWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 3600)
      return Math.round(val % 24)
    },
    formatMinWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 60)
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    },
    formatSecWorked (val) {
      if (!val) {
        return '-'
      }
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    }
  }
}
</script>
<style>
.chat-container {
  box-sizing: border-box;
  height: calc(90vh - 8rem);
  overflow-y: auto;
  padding: 10px;
  margin-top: 45px;
  margin-bottom: 56px;
  background-color: #f2f2f2;
}

.custom-toolbar.v-toolbar__content,
.v-toolbar__extension {
  padding: 0px !important
}

.centered-input input {
  text-align: end
}

.blur-content {
  filter: blur(5px);
}
</style>
